import { render } from "./AdamKarp.vue?vue&type=template&id=7c854406&ts=true"
import script from "./AdamKarp.vue?vue&type=script&lang=ts"
export * from "./AdamKarp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__